import { injectable } from "inversify";
import SidebarMenuItemType from "../enums/SidebarMenuItemType";
import RouteParam from "../models/RouteParam";
import SidebarMenuItem from "../models/SidebarMenuItem";
import ISidebarService from "./ISidebarService";

@injectable()
export default class SidebarService implements ISidebarService {

  getCurrentCardIdByRoute(routePath: string, sidebarMenuItems: SidebarMenuItem[]): string {
    let id = "";

    for (const item of sidebarMenuItems) {
      if (item.routePath === routePath) {
        id = item.id;
        break;
      } 
      else if (item.childItems && item.childItems.length > 0) {
        let childMenuItem = item.childItems.find(
          (o) =>
            this.getRouteWithParams(o.routePath, o.routeParams) === routePath
        );

        if (childMenuItem !== undefined) {
          id = item.id;
          break;
        }
      }
    }

    return id;
  }

  getRouteWithParams(routePath?: string, routeParams?: RouteParam[], createRouteTemplate = false): string {
    let finalRoute = routePath ?? "";

    if (routeParams && routeParams.length > 0) {
      let params = routeParams.map((x) => createRouteTemplate ? x.name : x.value).join(createRouteTemplate ? "/:" : "/");
      finalRoute += `${createRouteTemplate ? "/:" : "/"}${params}`;
    }

    return finalRoute;
  }

  getMenuItemsFromJson(json: any): SidebarMenuItem[] {
    return json as SidebarMenuItem[];
  }

  getMenuItemsToRegistration(sidebarMenuItems: SidebarMenuItem[]): SidebarMenuItem[] {
    let result: SidebarMenuItem[] = [];
    
    for (const item of sidebarMenuItems) {
      if (item.type == SidebarMenuItemType.Route && !result.some(x => x.moduleName == item.moduleName)) {
        result.push(item);
      }
      else if (item.type == SidebarMenuItemType.Collapse && item.childItems) {
        for (const child of item.childItems) {
          if (!result.some(x => x.moduleName == child.moduleName)) {
            result.push(child);
          }
        }
      }
    }
    
    return result;
  }
}
